/**
 * Skyrover IDE protocol and application constants.
 * Shared by web app and documented for the Go helper.
 */

/** Helper REST/WebSocket protocol version — bump on breaking API changes */
export const PROTOCOL_VERSION = '1.0.0' as const;

/** Default localhost port for the Skyrover helper application */
export const HELPER_DEFAULT_PORT = 7421 as const;

/** Base path for helper REST API v1 */
export const HELPER_API_BASE_PATH = '/api/v1' as const;

/** WebSocket endpoint path on the helper */
export const HELPER_WS_PATH = '/ws' as const;

/** Project file format version embedded in .skyrover archives */
export const PROJECT_FORMAT_VERSION = '1.0.0' as const;

/** Project file extension */
export const PROJECT_FILE_EXTENSION = '.skyrover' as const;

/** Allowed CORS origins for helper (production + staging) */
export const HELPER_ALLOWED_ORIGINS = [
  'https://ide.liwettechnologies.com',
  'https://ide.skyrover.dev',
  'https://staging.skyrover.dev',
] as const;

/** Development origin — helper may allow in dev builds only */
export const HELPER_DEV_ORIGIN = 'http://localhost:5173' as const;

/** Default serial monitor baud rate */
export const SERIAL_DEFAULT_BAUD = 115200 as const;

/** Supported serial baud rates */
export const SERIAL_SUPPORTED_BAUDS = [
  9600, 19200, 38400, 57600, 115200, 230400, 460800, 921600,
] as const;

/** Line ending options for serial monitor send */
export const SERIAL_LINE_ENDINGS = ['none', 'nl', 'cr', 'crlf'] as const;
export type SerialLineEnding = (typeof SERIAL_LINE_ENDINGS)[number];

/** Blockly workspace autosave debounce (ms) */
export const WORKSPACE_AUTOSAVE_DEBOUNCE_MS = 500 as const;

/** Helper connection poll interval when disconnected (ms) */
export const HELPER_RECONNECT_INTERVAL_MS = 2000 as const;

/** Minimum helper auth token length */
export const HELPER_TOKEN_MIN_LENGTH = 32 as const;

/** Windows helper installer path on the hosted IDE (upload this file with the web dist). */
export const HELPER_DOWNLOAD_PATH = '/downloads/SkyroverHelperSetup.exe' as const;
